/**
 * @generated SignedSource<<3178f51cbe2f0f3a669badf345c2ac10>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GivePointsPaymentModal_tenant$data = {
  readonly incentivesOrderFulfillmentVerificationDays: number | null;
  readonly requireStudyPayment: boolean;
  readonly stripePaymentMethodId: string | null;
  readonly stripePaymentMethodLast4: string | null;
  readonly " $fragmentType": "GivePointsPaymentModal_tenant";
};
export type GivePointsPaymentModal_tenant$key = {
  readonly " $data"?: GivePointsPaymentModal_tenant$data;
  readonly " $fragmentSpreads": FragmentRefs<"GivePointsPaymentModal_tenant">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GivePointsPaymentModal_tenant",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "requireStudyPayment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "incentivesOrderFulfillmentVerificationDays",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stripePaymentMethodId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stripePaymentMethodLast4",
      "storageKey": null
    }
  ],
  "type": "TenantNode",
  "abstractKey": null
};

(node as any).hash = "55912071b67eb1bce02235022b211ce2";

export default node;
